// extracted by mini-css-extract-plugin
export default {"leadPanel":"leadPanel__j5MYDH","productLogo":"productLogo__I6K2N9"};